import './style.css';
import PainelCheckList from '../grafico/checklist';
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../context/AppContext.js';
import api from "../../services/api.js";
import confetti from 'canvas-confetti';
import PopUp from "../../../src/componente/popup/index.jsx";

const Dashboard = () => {

  const [isOpen, setIsOpen] = useState(false);

  const getFirstDayOfMonth = () => {
    const dt = new Date();
    return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
  };

  // Função para calcular a data atual
  const getCurrentDate = () => {
    const dt = new Date();
    return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
  };

  const { codassinante, selectedCompany, accessKey } = useAppContext();

  const [dt1, setdt1] = useState(getFirstDayOfMonth);
  const [dt2, setdt2] = useState(getCurrentDate);

  const [abusca, setabusca] = useState('');

  const [codsetor, setcodsetor] = useState('0');
  const [codfuncao, setcodfuncao] = useState('0');
  const [codequipe, setcodequipe] = useState('0');

  const [saldoreais, setsaldoreais] = useState(0);
  const [saldoreaisusado, setsaldoreaisusado] = useState(0);
  const [saldocoinpremio, setsaldocoinpremio] = useState(0);
  const [saldocoinpremiousado, setsaldocoinpremiousado] = useState(0);
  const [saldocoinchecklist, setsaldocoinchecklist] = useState(0);
  const [saldocoinchecklistusado, setsaldocoinchecklistusado] = useState(0);
  const [saldocoinranking, setsaldocoinranking] = useState(0);
  const [saldocoinrankingusado, setsaldocoinrankingusado] = useState(0);

  const [listaSetor, setListaSetor] = useState([]);
  const [listaFuncao, setListaFuncao] = useState([]);
  const [listaEquipe, setListaEquipe] = useState([]);

  const [aTipo, setaTipo] = useState('');

  const handleOpen = (cad) => {
    setaTipo(cad);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    handleTrophyClick(aTipo);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListaSetor() {
    api
      .get("v1/cadastro/setor", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setListaSetor(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListaFuncao() {
    api
      .get("v1/cadastro/funcao", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setListaFuncao(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListaEquipe() {
    api
      .get("v1/cadastro/equipe", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setListaEquipe(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarOrcamento() {
    api
      .get("v1/saldoorcamento", {
        params: {
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setsaldoreais(response.data.saldoreais);
        setsaldoreaisusado(response.data.saldoreaisusado);
        setsaldocoinpremio(response.data.saldocoinpremio);
        setsaldocoinpremiousado(response.data.saldocoinpremiousado);
        setsaldocoinchecklist(response.data.saldocoinchecklist);
        setsaldocoinchecklistusado(response.data.saldocoinchecklistusado);
        setsaldocoinranking(response.data.saldocoinranking);
        setsaldocoinrankingusado(response.data.saldocoinrankingusado);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(
    function () {
      ListaSetor();
      ListaFuncao();
      ListaEquipe();
      ListarOrcamento();
    },
    [selectedCompany]
  );

  async function handleTrophyClick(tipo) {
    try {
      await api.post("/v1/premio", {
        codempresa: selectedCompany,
        codassinante,
        tipo,
        busca: abusca,
        dt1,
        dt2,
        codsetor,
        codfuncao,
        codequipe
      },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },

        });
    } catch (error) {
      console.error('Erro ao excluir dados:', error);
    } finally {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 }
      });
    }
  }

  return (
    <div className="dashboard">
      <PopUp isOpen={isOpen} onClose={handleClose}>
        <h2>Verificação</h2>
        <p>Tem certeza que deseja premiar {aTipo === 'setor' ? ('o Setor') : aTipo === 'funcao' ? ('a Função') : ('a Equipe')}?</p>

        <div className="row">
          <div className="col-12 mt-3 d-flex justify-content-end">
            <button
              className="btn btn-primary me-2"
              onClick={handleConfirma}
            >
              Sim
            </button>
            <button className="btn btn-danger" onClick={handleClose}>
              Não
            </button>
          </div>
        </div>
      </PopUp>

      <h3 className='text-center'>CheckList</h3>

      <div className='row'>
        <div className="col-6">
          <label className="form-label" htmlFor="busca">
            Busque aqui
          </label>
          <input
            type="text"
            placeholder="Buscar por: Nome do profissional"
            name="busca"
            id="busca"
            className="form-control me-3"
            value={abusca}
            onChange={(e) => setabusca(e.target.value)}
          />
        </div>

        <div className="col-2">
          <label htmlFor="dt1" className="form-label">
            Tarefas de...
          </label>
          <input
            type="date"
            id="dt1"
            className="form-control"
            placeholder="Dt. Lançamento"
            value={dt1}
            onChange={(e) => setdt1(e.target.value)}
          />
        </div>

        <div className="col-2">
          <label htmlFor="dt2" className="form-label">
            Para...
          </label>
          <input
            type="date"
            id="dt2"
            className="form-control"
            placeholder="Dt. Lançamento"
            value={dt2}
            onChange={(e) => setdt2(e.target.value)}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-sm-4">
          <label htmlFor="setor" className="form-label">Setor</label>
          <div className="d-flex align-items-end">
            <select
              className="form-select me-2"
              id="setor"
              value={codsetor}
              onChange={(e) => setcodsetor(e.target.value)}
            >
              <option value="0">Escolha o setor</option>
              {listaSetor.map((set) => (
                <option key={set.codsetor} value={set.codsetor}>
                  {set.descricao}
                </option>
              ))}
            </select>
            <button
              type="button"
              className="btn btn-warning"
              title="Ver ranking por setor"
              onClick={() => handleOpen('setor')}
            >
              <i className="fa-solid fa-trophy"></i>
            </button>
          </div>
        </div>

        <div className="col-sm-4">
          <label htmlFor="funcao" className="form-label">Função</label>
          <div className="d-flex align-items-end">
            <select
              className="form-select me-2"
              id="funcao"
              value={codfuncao}
              onChange={(e) => setcodfuncao(e.target.value)}
            >
              <option value="0">Escolha a função</option>
              {listaFuncao.map((fun) => (
                <option key={fun.codfuncao} value={fun.codfuncao}>
                  {fun.descricao}
                </option>
              ))}
            </select>
            <button
              type="button"
              className="btn btn-warning"
              title="Ver ranking por função"
              onClick={() => handleOpen('funcao')}
            >
              <i className="fa-solid fa-trophy"></i>
            </button>
          </div>
        </div>

        <div className="col-sm-4">
          <label htmlFor="equipe" className="form-label">Equipe</label>
          <div className="d-flex align-items-end">
            <select
              className="form-select me-2"
              id="equipe"
              value={codequipe}
              onChange={(e) => setcodequipe(e.target.value)}
            >
              <option value="0">Escolha a equipe</option>
              {listaEquipe.map((eq) => (
                <option key={eq.codequipe} value={eq.codequipe}>
                  {eq.descricao}
                </option>
              ))}
            </select>
            <button
              type="button"
              className="btn btn-warning"
              title="Ver ranking por equipe"
              onClick={() => handleOpen('equipe')}
            >
              <i className="fa-solid fa-trophy"></i>
            </button>

          </div>
        </div>
      </div>

      <br />

      <div className='row'>
        {/* CARD 1 - Saldo em Reais */}        
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <div className="card border-primary shadow-sm h-100">
            <div className="card-header bg-primary text-white">
              <i className="fa-solid fa-money-bill-wave me-2"></i>Saldo em Reais
            </div>
            <div className="card-body">
              <h5 className="card-title">
                Saldo:{" "}
                <span className="text-primary">
                  {saldoreais.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </span>
              </h5>
              <p className="card-text">
                Usado:{" "}
                <strong>
                  {saldoreaisusado.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </strong>
              </p>
              <div className="progress mt-3" style={{ height: "8px" }}>
                <div
                  className="progress-bar bg-primary"
                  role="progressbar"
                  style={{
                    width: `${saldoreais > 0
                        ? (saldoreaisusado / saldoreais) * 100
                        : 0
                      }%`,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        {/* CARD 2 - Coin Prêmio */}
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <div className="card border-success shadow-sm h-100">
            <div className="card-header bg-success text-white">
              <i className="fa-solid fa-gift me-2"></i>Saldo Coin Prêmio
            </div>
            <div className="card-body">
              <h5 className="card-title">
                Saldo:{" "}
                <span className="text-success">
                  {saldocoinpremio.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </span>
              </h5>
              <p className="card-text">
                Usado:{" "}
                <strong>
                  {saldocoinpremiousado.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </strong>
              </p>
              <div className="progress mt-3" style={{ height: "8px" }}>
                <div
                  className="progress-bar bg-success"
                  role="progressbar"
                  style={{
                    width: `${saldocoinpremio > 0
                        ? (saldocoinpremiousado / saldocoinpremio) * 100
                        : 0
                      }%`,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        {/* CARD 3 - Coin Checklist */}
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <div className="card border-warning shadow-sm h-100">
            <div className="card-header bg-warning text-dark">
              <i className="fa-solid fa-clipboard-check me-2"></i>Saldo Coin Checklist
            </div>
            <div className="card-body">
              <h5 className="card-title">
                Saldo:{" "}
                <span className="text-warning">
                  {saldocoinchecklist.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </span>
              </h5>
              <p className="card-text">
                Usado:{" "}
                <strong>
                  {saldocoinchecklistusado.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </strong>
              </p>
              <div className="progress mt-3" style={{ height: "8px" }}>
                <div
                  className="progress-bar bg-warning"
                  role="progressbar"
                  style={{
                    width: `${saldocoinchecklist > 0
                        ? (saldocoinchecklistusado / saldocoinchecklist) * 100
                        : 0
                      }%`,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        {/* CARD 4 - Coin Ranking */}
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <div className="card border-danger shadow-sm h-100">
            <div className="card-header bg-danger text-white">
              <i className="fa-solid fa-trophy me-2"></i>Saldo Coin Ranking
            </div>
            <div className="card-body">
              <h5 className="card-title">
                Saldo:{" "}
                <span className="text-danger">
                  {saldocoinranking.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </span>
              </h5>
              <p className="card-text">
                Usado:{" "}
                <strong>
                  {saldocoinrankingusado.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </strong>
              </p>
              <div className="progress mt-3" style={{ height: "8px" }}>
                <div
                  className="progress-bar bg-danger"
                  role="progressbar"
                  style={{
                    width: `${saldocoinranking > 0
                        ? (saldocoinrankingusado / saldocoinranking) * 100
                        : 0
                      }%`,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      <PainelCheckList dt1={dt1} dt2={dt2} busca={abusca} codsetor={codsetor} codfuncao={codfuncao} codequipe={codequipe} />
    </div>
  );
};

export default Dashboard;